export default __webpack_public_path__ + "static/media/weather.589d9393.svg";